var App = App || {};

App.SmartAppBanner = (function ($) {
    'use strict';

    function isIphone() {
        return /iPhone/i.test(window.navigator.userAgent || '');
    }

    function hasNativeAppleBannerMeta() {
        const meta = document.querySelector('meta[name="apple-itunes-app"]');
        const content = meta ? (meta.getAttribute('content') || '') : '';

        return /app-id=/i.test(content);
    }

    function Init() {
        const iphone = isIphone();

        if (iphone && hasNativeAppleBannerMeta()) {
            document.documentElement.classList.add('smartbanner-native-ios');
            return;
        }

        const options = {
            daysHidden: 15,   // days to hide banner after close button is clicked (defaults to 15)
            daysReminder: 90, // days to hide banner after "VIEW" button is clicked (defaults to 90)
            appStoreLanguage: 'us', // language code for the App Store (defaults to user's browser language)
            title: 'Dime Bank',
            author: 'Financial Institution',
            button: 'VIEW',
            store: {
                ios: 'On the App Store',
                android: 'In Google Play',
                windows: 'In Windows store'
            },
            price: {
                ios: 'FREE',
                android: 'FREE',
                windows: 'FREE'
            }
        };

        if (iphone) {
            options.force = 'ios';
        }

        new SmartBanner(options);
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.SmartAppBanner.Init();
});